import { useMutation } from '@tanstack/react-query';
import { message } from 'antd';

import type { VoucherForm } from 'app/typings/voucher';
import { apiMutation } from 'app/utils/request/api';

const voucherPath = 'vouchers' as const;
const deleteOrUpdateVoucherPath = 'vouchers/:voucherCode' as const;

export function useDeleteVoucher(voucherCode?: string) {
  return useMutation({
    mutationFn: !!voucherCode
      ? async () =>
          apiMutation('DELETE', {
            path: deleteOrUpdateVoucherPath,
            params: { voucherCode },
          }) as Promise<void>
      : async () => {
          /* no-op */
        },
    onSuccess: () => {
      message.success('Voucher deleted');
    },
    onError: () => {
      message.error('Failed to delete voucher', 10);
    },
  });
}

export function useCreateVoucher(options?: {
  onSuccess?: (data: void, variables: VoucherForm) => void;
  onError?: () => void;
}) {
  return useMutation({
    mutationFn: async (payload: VoucherForm) =>
      apiMutation('POST', { path: voucherPath }, payload) as Promise<void>,
    onSuccess: (data, variables) => {
      message.success('Voucher created');
      options?.onSuccess?.(data, variables);
    },
    onError: () => {
      message.error('Failed to create voucher', 10);
      options?.onError?.();
    },
  });
}

export function useUpdateVoucher(voucherCode?: string) {
  return useMutation({
    mutationFn: !!voucherCode
      ? async (payload: VoucherForm) =>
          apiMutation(
            'PUT',
            {
              path: deleteOrUpdateVoucherPath,
              params: { voucherCode },
            },
            payload
          ) as Promise<void>
      : async () => {
          /* no-op */
        },
    onSuccess: () => {
      message.success('Voucher updated');
    },
    onError: () => {
      message.error('Failed to update voucher', 10);
    },
  });
}
